import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {QuillModule} from 'ngx-quill';
import {ImageShortcodeActionSheet} from '../../action-sheet/image-shortcode-action-sheet';

import {BodyInput} from './body.input';
import {QuillToolbarModule} from './quill-toolbar/quill-toolbar.module';

/**
 * Module for the body input
 */
@NgModule({
  declarations: [BodyInput],
  exports: [BodyInput],
  imports: [
    IonicModule,
    QuillModule,
    QuillToolbarModule,
  ],
  providers: [ImageShortcodeActionSheet],
})
export class BodyInputModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/body.module.ts